import { createFileRoute } from '@tanstack/react-router'
import DemoTools from '../components/demo/DemoTools'

export const Route = createFileRoute('/_a/demoTools')({
  component: DemoTools,
})
